var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 78,
    viewBox: "0 0 70 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.9993 52L69.9993 49.1111V54.8889V60.6667L64.9993 63.5556L59.9993 66.4444V60.6667V54.8889L64.9993 52ZM19.9995 37.5556V43.3333V49.1111V54.8889V60.6667L15.0001 57.7778L10.0007 54.8889V49.1111V31.7778V26L15.0001 23.1111L29.9996 14.4444L34.9997 11.5556L39.9997 8.66667L44.9991 5.77778L39.9997 2.88889L34.9997 0L29.9996 2.88889L5.00005 17.3333L0 20.2222V26V54.8889V60.6667L5.00005 63.5556L29.9996 78V66.4444V54.8889V49.1111V43.3333L24.9996 40.4444L19.9995 37.5556ZM64.9993 17.3333L54.9999 11.5556L50.0005 14.4444L45.0004 17.3333L40.001 20.2222L35.001 23.1111L30.0009 26L25.0015 28.8889L30.0009 31.7778L35.001 34.6667L40.001 31.7778L45.0004 28.8889L50.0005 26L54.9999 23.1111L59.9999 26V31.7778L54.9999 34.6667L50.0005 37.5556L45.0004 40.4444L40.001 43.3333V49.1111V54.8889V66.4444V78L50.0005 72.2222V60.6667V54.8889V49.1111L54.9999 46.2222L59.9999 43.3333L65 40.4444L70 37.5556V31.7778V20.2222L64.9993 17.3333Z",
    fill: "#8f48ff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPurple);
export default __webpack_public_path__ + "static/media/logo-purple.047a220e.svg";
export { ForwardRef as ReactComponent };